module.exports = __webpack_public_path__ + "media/message 16.4b14ef15.mp3";